import { Validation } from './Validation';
import { UserPermissionRank } from './UserPermissionRank';
import UserPermissionJson from './UserPermission';


export default interface UserJson {
   ID: number | null;
   firstName: string;
   lastName: string;
   email: string;
   phone: string;
   userPermissions: UserPermissionJson[];
   permissionRank: UserPermissionRank;
}

export function defaultUserJson() {
   return {
      ID: null,
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      userPermissions: [],
      permissionRank: UserPermissionRank.staff
   };
}

export function validateUserJson(item: UserJson) {
   return new Validation(item)
      .validateNonEmptyString("firstName", 100)
      .validateNonEmptyString("lastName", 100)
      .validateEmail("email")
      .validateString("phone", 100)
      .finish();
}